import { useRecoilValue } from 'recoil'
import { useParams } from 'react-router'
import {
  PartnerListData,
  RecoilStateList,
  uiVerifyStyle,
} from 'src/recoil/common'

import useAPI from 'src/hooks/useAPI'
import { PartnerListType } from 'src/types/type'
import {
  JoinSubmitWrap
} from 'src/styles/styledcomponent/views/mkt04/JoinSubmit'
import {Button} from "src/components/views/mkt04/Button";

const JoinSubmit = (props: any): JSX.Element => {
  const params = useParams()
  const { submit } = props

  const PartnerData: PartnerListType = useRecoilValue(PartnerListData)
  const api = useAPI('requestJoin')
  const { TelType, PhoneNum, CertNum, authKeyValue, termsAgree, TransId, TermsData } =
    useRecoilValue(RecoilStateList)
  const { verifyBtn } = useRecoilValue(uiVerifyStyle)
  const { mutateAsync: JoinRequest, isLoading } = api.useSetMutation({
    TranID: TransId,
    Telecom: TelType,
    PNumber: PhoneNum,
    PCode: params.pcode,
    ApprovalNumber: Number(CertNum),
    TermsIdx: TermsData?.TermsIdx,
    TermsAgree: termsAgree.join(""),
    authKey: authKeyValue,
  })
  const { Timeout } = useRecoilValue(RecoilStateList)
  const isOtpValidLen = /^\d{4}$/.test(String(CertNum || ''))
  const isOtpInTime   = Number(Timeout) > 0
  const isOtpReady    = isOtpValidLen && isOtpInTime

  const loading = Boolean(submit?.joinLoading) || isLoading
  const disabled = loading || !isOtpReady


  return (
    <>
      <JoinSubmitWrap>
        <Button.JoinSubmit
           type="button"  
          className="btn_signup"
          {...verifyBtn}
          backgroundColor={verifyBtn.backgroundColor}
          onClick={() => submit.join(JoinRequest)}
          isLoading={loading}
          disabled={disabled}
        >
          {PartnerData.ButtonMsgAfter}
        </Button.JoinSubmit>
      </JoinSubmitWrap>

    </>
  )
}
export default JoinSubmit
